import type { Store } from 'vuex';
import { useVm } from './useVm';

export function useStore<S = Record<string, unknown>>(): Store<S> {
  return useVm().$store as Store<S>;
}
